export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "view_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View less"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
      },
      "fr": {
        "view_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])}
      }
    }
  })
}